import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEtapaObra'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetAllObra = (empreedimentoid, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllObra/${empreedimentoid}`, data, config)

const WorkStageRepository = {
  GetAll,
  GetAllObra

}

export default WorkStageRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/workstage.js